import "./ProjectTreeRowCircleStatus.css";

const ProjectTreeRowCircleStatus = ({ rowObj }) => {
	if (rowObj.double_is_winner === false) return <></>;

	if (rowObj?.valid_status === "success") {
		return <span className="status-round status-success"></span>;
	} else if (rowObj?.valid_status === "warning") {
		return <span className="status-round status-warning"></span>;
	} else if (rowObj?.valid_status === "error") {
		return <span className="status-round status-error"></span>;
	} else {
		return <></>;
	}
};

export default ProjectTreeRowCircleStatus;
